import styleInject from 'style-inject';

var css_248z = ".ThemeModeSelector-module_container__sUVm4>svg{align-self:center;cursor:pointer}.ThemeModeSelector-module_iconWrapper__WpeXd{cursor:pointer;opacity:.4}.ThemeModeSelector-module_selected__Xzif-{opacity:1}";
var styles = {"container":"ThemeModeSelector-module_container__sUVm4","iconWrapper":"ThemeModeSelector-module_iconWrapper__WpeXd","selected":"ThemeModeSelector-module_selected__Xzif-"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGhlbWVNb2RlU2VsZWN0b3IubW9kdWxlLnNjc3MuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OzsifQ==
